export const SCENE_POST_MESSAGE_TYPES = {
  PREVIEW_CLOSED: 'SCENE_PREVIEW_CLOSED',
  INVALIDATE_SCENE_SUBSCRIPTIONS: 'SCENE_INVALIDATE_SUBSCRIPTIONS'
} as const;
